import { render, staticRenderFns } from "./QuizTable.vue?vue&type=template&id=53d044b6&"
import script from "./QuizTable.vue?vue&type=script&lang=js&"
export * from "./QuizTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports